import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Sincronizacion } from '../../_models/sincronizacion';
import { SincronizacionService } from '../../_services/sincronizacion.service';

@Component( {
  selector: 'app-sincronizacion-editar',
  templateUrl: 'sincronizacion-editar.component.html'
} )

export class SincronizacionEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  tabExiste = false;
  guardando = false;
  sincronizacion: Sincronizacion;
  lisSincronizaciones: Sincronizacion[] = [];
  formulario: FormGroup;
  submitted = false;

  constructor( private sinServicio: SincronizacionService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.sinServicio.obtenerPorId( params[ 'id' ] ).subscribe( sincronizacion => {
          this.sincronizacion = sincronizacion;
          this.carServiciosIniciales();
          this.carInformacionInicial = false;
        } );
      } else {
        this.carServiciosIniciales();
      }
    } );
  }

  carServiciosIniciales() {
    this.formulario = this.fb.group( {
      idSincronizacion: [ this.sincronizacion ? this.sincronizacion.idSincronizacion : null ],
      codigo: [ this.sincronizacion ? this.sincronizacion.codigo : null, [ Validators.required, Validators.maxLength( 20 ) ] ],
      tabla: [ this.sincronizacion ? this.sincronizacion.tabla : null, [ Validators.required, Validators.maxLength( 120 ) ] ],
      fechaSincronizacion: [ this.sincronizacion ? this.sincronizacion.fechaSincronizacion : null ],
      indicadorTablaEstatica: [ this.sincronizacion ? this.sincronizacion.indicadorTablaEstatica : false ],
      indicadorHabilitado: [ this.sincronizacion ? this.sincronizacion.indicadorHabilitado : true ],
      auditoriaUsuario: [ this.sincronizacion ? this.sincronizacion.auditoriaUsuario : null ],
      auditoriaFecha: [ this.sincronizacion ? this.sincronizacion.auditoriaFecha : null ],
    } );
    this.sinServicio.listado().subscribe( sincronizaciones => {
      this.lisSincronizaciones = sincronizaciones;
      this.carInformacionInicial = false;
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && !this.tabExiste && this.formulario.valid ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_GUARDARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.guardando = true;
          const sincronizacion = this.formulario.value;
          if ( sincronizacion.idSincronizacion) {
            this.sinServicio.actualizar( sincronizacion ).subscribe( rta => {
              this.navServicio.setMesage( 2 );
              this.guardando = false;
              this.location.back();
            }, error => {
              this.navServicio.setMesage( 3 );
              this.guardando = false;
            } );
          } else {
            this.sinServicio.crear( sincronizacion ).subscribe( rta => {
              sincronizacion.idSincronizacion = rta.idSincronizacion;
              this.f.idSincronizacion.setValue( rta.idSincronizacion );
              this.navServicio.setMesage( 1 );
              this.guardando = false;
              this.location.back();
            }, error => {
              this.navServicio.setMesage( 3 );
              this.guardando = false;
            } );
          }
        },
        reject: () => {
        }
      } );
    }
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = !!this.lisSincronizaciones.find( x => this.f.codigo.value && x.codigo && x.codigo.toLowerCase() === this.f.codigo.value.toLowerCase() && (!this.sincronizacion || this.sincronizacion.idSincronizacion !== x.idSincronizacion) );
  }

  validarTabla() {
    this.tabExiste = !!this.lisSincronizaciones.find( x => x.tabla && this.f.tabla.value && x.tabla.toLowerCase() === this.f.tabla.value.toLowerCase() && (!this.sincronizacion || this.sincronizacion.idSincronizacion !== x.idSincronizacion) );
  }

  get f() {
    return this.formulario.controls;
  }

}
